import { Add, GridView } from "@mui/icons-material";
import HeaderTable from "../../Components/HeaderTable/HeaderTable";
import { ButtonTable } from "../../Layouts/ButtonsControlled";
import { useLocation } from "react-router-dom";
import { Outlet, Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import {Grid, Box} from "@mui/material";

const Addersv2 = () => {
    const location = useLocation();
    const path = location.pathname.split("/")[2];
    const { parent_id } = useParams();

    return (
        <>
            <HeaderTable>
                <div className="title">
                    <GridView />
                    <span>{path}</span>
                </div>

            <Box>
                <Grid container columns={12} spacing={3}>
                
                    <Grid item mb={1} xs={6} md={6}>
                                <Link mr={2} to="/dashboard/adders-categories">
                                    <ButtonTable>Adders Groups</ButtonTable>
                                </Link>
                    </Grid>
                    {parent_id ? (
                            <Grid item mb={1} xs={6} md={6}>
                                <Link mr={2} to={"/dashboard/adders/v2/add-child=" + parent_id}>
                                    <ButtonTable startIcon={<Add />}>New</ButtonTable>
                                </Link>
                            </Grid>
                        ) : (
                            <Grid item mb={1} xs={6} md={6}>
                                <Link mr={2} to="/dashboard/adders/v2/create">
                                    <ButtonTable startIcon={<Add />}>New</ButtonTable>
                                </Link>
                            </Grid>
                        )}
                </Grid>
            </Box>
            </HeaderTable>
            <Outlet />
        </>
    );
};

export default Addersv2;
